import moment from 'moment';

export default (iso8601Date) => {
  if (iso8601Date) {
    return moment(String(iso8601Date)).format('YYYY/MM/DD');
  }
  return '';
};
